
import { combineReducers } from 'redux';
import practice from './practice';
import errors from './errors';
import onboarding from './onboarding';
import owners from './owners';
import significantController from './significant-controller';

export default combineReducers({
  practice,
  errors,
  onboarding,
  owners,
  significantController
});

